import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const approvalRoutes: PermissionedRouteObject[] = [
  {
    children: [
      {
        path: "return/:returnId",
        async lazy() {
          const { ApproveReturn } = await import("./approve-return");
          return { Component: ApproveReturn };
        },
      },
    ],
  },
];
